import { storeToRefs } from 'pinia';
import SignInModal from '@/components/SignInModal.vue';
import SignUpModal from '@/components/SignUpModal.vue';
import { useRedirect } from '@/composables/useRedirect';
import { useSettingsStore } from '@/store/useSettingsStore';
import { useModal, ModalOptions } from '@/storybook/modal/useModal';
import { useVfm } from 'vue-final-modal';

export interface AuthModalProps {
  hideCloseButton?: boolean;
  signup: {
    sidebarText?: string;
    redirectUrl?: string;
    showModalForFreeTier?: boolean;
    signedUpFrom?: string;
    utmContent?: string;
  };
}

export const useAuthModals = () => {
  const vfm = useVfm();
  const { isCustomDomain, loginUrl, signupUrl } = storeToRefs(useSettingsStore());
  const { getURLToBaseDomain } = useRedirect();

  const showSignInModal = (redirectUrl?: string, modalOptions: ModalOptions = {}) => {
    vfm.closeAll();

    if (isCustomDomain?.value && loginUrl?.value) {
      let url = loginUrl?.value;

      if (redirectUrl) {
        url = `${url}?return_to=${redirectUrl}`;
      }

      window.location.assign(url);
      return Promise.resolve();
    }

    const redirect = getURLToBaseDomain('login');

    if (redirect) {
      window.location.assign(redirect);
      return;
    }

    modalOptions.noBorder = true;
    modalOptions.closeButtonInset = 'large';
    modalOptions.closeButtonTheme = 'light';

    const { open } = useModal(SignInModal, { ...modalOptions, modalProps: { redirectUrl } });
    return open();
  };

  const showSignUpModal = (
    { sidebarText, redirectUrl, showModalForFreeTier, signedUpFrom, utmContent }: AuthModalProps['signup'] = {},
    modalOptions: ModalOptions = {}
  ) => {
    vfm.closeAll();

    if (isCustomDomain?.value && signupUrl?.value) {
      let url = signupUrl?.value;

      if (redirectUrl) {
        url = `${url}?return_to=${redirectUrl}`;
      }

      window.location.assign(url);
      return Promise.resolve();
    }

    const redirect = getURLToBaseDomain('signup');

    if (redirect) {
      window.location.assign(redirect);
      return;
    }

    modalOptions.noBorder = true;
    modalOptions.closeButtonInset = 'large';
    modalOptions.closeButtonTheme = 'light';

    const { open } = useModal(SignUpModal, {
      ...modalOptions,
      modalProps: { sidebarText, redirectUrl, showModalForFreeTier, signedUpFrom, utmContent },
    });
    return open();
  };

  return { showSignInModal, showSignUpModal };
};
